import { AppThunk } from 'redux/reducers/rootReducer';
import { IGenericDataFetchParams, createGenericDataFetch } from '../generic/GenericDataActions';
import { setFetchInvoicelinesByInvoiceIdPending, setFetchInvoicelinesByInvoiceIdSucces, setFetchInvoicelinesByInvoiceIdError } from 'redux/reducers/data_action_reducers/invoices/InvoiceLinesByInvoiceIdReducer';
import { IInvoiceLine } from 'types/backend_models/invoices/IInvoiceLine';

var fetchParams: IGenericDataFetchParams<IInvoiceLine[]> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchInvoicelinesByInvoiceIdPending,
	succesActionCreator: setFetchInvoicelinesByInvoiceIdSucces,
	errorActionCreator: setFetchInvoicelinesByInvoiceIdError
}

export function fetchInvoiceLinesByInvoiceId(invoiceId: number): AppThunk
{
	fetchParams.apiEndPoint = `customer/invoices/${invoiceId}/lines`;
	return createGenericDataFetch<IInvoiceLine[]>(fetchParams);
}